export const CTA_VARIANT_CLASSES = {
  primary:
    "bg-pi-accent text-white border border-pi-accent shadow-[0_8px_24px_rgba(90,75,218,0.32)] transition-[filter] hover:brightness-110",
  outline:
    "bg-transparent border border-pi-border-muted text-pi-bright transition-colors hover:border-pi-accent hover:text-pi-accent-soft",
  /** High-urgency gold CTA used for the hero and the recommended pricing plan. */
  gold: "bg-pi-gold text-[#1a1200] border border-pi-gold shadow-[0_8px_24px_rgba(255,198,26,0.28)] transition-[filter] hover:brightness-110",
};

export const CTA_SIZE_CLASSES = {
  small: "rounded-xl px-[18px] py-2.5 text-sm",
  medium: "rounded-xl px-6 py-3.5 text-[15px]",
  large: "rounded-xl px-8 py-4 text-base md:text-lg",
  /** Pill CTA used in the hero. */
  hero: "rounded-full px-[30px] py-4 text-base md:text-lg",
};

/** Shared button styling for every `AuthButton`, whether it renders a button or a checkout link. */
export function getCtaClassName({
  variant = "primary",
  size = "medium",
  className = "",
}: {
  variant?: keyof typeof CTA_VARIANT_CLASSES;
  size?: keyof typeof CTA_SIZE_CLASSES;
  className?: string;
} = {}) {
  return `inline-block cursor-pointer text-center font-semibold no-underline ${CTA_VARIANT_CLASSES[variant]} ${CTA_SIZE_CLASSES[size]} ${className}`;
}
